import { Dictionary } from '../../utils/languages';

const translations = {
  'Current Leverage': {
    ENG: 'Current Leverage'
  },
  'New Leverage': {
    ENG: 'New Leverage'
  },
  'Liquidation Prices': {
    ENG: 'Liquidation Prices'
  },
  'New Liquidation Prices': {
    ENG: 'New Liquidation Prices'
  },
  'TWAP Price': {
    ENG: 'TWAP Price'
  }
} as Dictionary;

export default translations;
